import Flickity from "flickity";

const lsg_carousel_rebuild = { 
    init: () => {
        

        const carouselSectionEls    = document.querySelectorAll(`.lsg-carousel-rebuild`);

        carouselSectionEls.forEach((carouselSectionEl) => {
            buildCarousel(carouselSectionEl);
        });

        function buildCarousel(carouselSectionEl) {
            const sectionId         = carouselSectionEl.getAttribute(`data-section-id`),
                  carouselSettings  = JSON.parse(document.getElementById(`CarouselSettings-${sectionId}`).textContent),
                  carouselActualEl  = carouselSectionEl.querySelector(`[lsg-carousel]`);
    
            let carouselEl;
    
            if (carouselActualEl) {
                let carouselNavEl       = carouselSectionEl.querySelector(`[lsg-carousel-nav]`),
                    navPrevEl           = carouselNavEl.querySelector(`[lsg-carousel-nav-prev]`),
                    navDotsEl           = carouselNavEl.querySelector(`[lsg-carousel-nav-dots]`),
                    navDotEls           = carouselNavEl.querySelectorAll(`[lsg-carousel-nav-dot]`),
                    navNextEl           = carouselNavEl.querySelector(`[lsg-carousel-nav-next]`);
                
                function initCarousel(element, settings) {
                    // Non-customizable settings
                    settings.prevNextButtons    = false // custom
                    settings.pageDots           = false // custom
                    settings.percentPosition    = false
                    //settings.imagesLoaded       = true
                    settings.on = {
                        change: (index) => {
                            updateNav(index);
                        }
                    };
    
                    carouselEl = new Flickity(element, settings);
    
                    widthChecker();
                    setSliderHeightToMax(carouselEl);
                };
                initCarousel(carouselActualEl, carouselSettings);
    
                initNav(carouselSectionEl, carouselSettings);
    
    
                /* Width Checker */
                function widthChecker() {
                    if (carouselEl && carouselActualEl.clientWidth > carouselEl.slideableWidth) {
                        carouselEl.cells.forEach(cell => cell.element.style.height = '');
                        carouselEl.destroy();
                    } else if (!carouselEl || !carouselEl.isActive) {
                        carouselEl = new Flickity(carouselActualEl, carouselSettings);
                    }
                };
    
    
                /* Height Handler */
                function setSliderHeightToMax(carouselEl) {
                    carouselEl.cells.forEach(cell => cell.element.style.height = '');
    
                    let heights = carouselEl.cells.map(cell => cell.element.offsetHeight),
                        max = Math.max.apply(Math, heights);
    
                    carouselEl.cells.forEach(cell => cell.element.style.height = max + 'px');
                };
    
    
                /* Resize Handling */
                window.addEventListener('resize', () => {
                    carouselEl.resize();
                    widthChecker();
                    setSliderHeightToMax(carouselEl);
                });
    
    
                /* Nav Handling */
                function initNav(element, settings) {
                    carouselNavEl     = element.querySelector(`[lsg-carousel-nav]`);
                    navPrevEl         = carouselNavEl.querySelector(`[lsg-carousel-nav-prev]`);
                    navDotsEl         = carouselNavEl.querySelector(`[lsg-carousel-nav-dots]`);
                    navDotEls         = carouselNavEl.querySelectorAll(`[lsg-carousel-nav-dot]`);
                    navNextEl         = carouselNavEl.querySelector(`[lsg-carousel-nav-next]`);
                    updateNav(settings.initialIndex);
                }
    
                function updateNav(index) {
                    navDotEls.forEach((navDotEl) => {
                        navDotEl.parentElement.classList.remove(`lsg-dot-selected`);
                    });
    
                    const currentNavDotEl = carouselNavEl.querySelector(`[lsg-carousel-nav-dot-index="${index}"]`);
                    if (currentNavDotEl) {
                        currentNavDotEl.parentElement.classList.add(`lsg-dot-selected`);
                    }
    
                    if (navPrevEl && navNextEl) {
                        navPrevEl.removeAttribute(`disabled`);
                        navNextEl.removeAttribute(`disabled`);
    
                        if (!carouselEl.isWrapping && index === 0) {
                            navPrevEl.setAttribute(`disabled`, true);
                        } else if (!carouselEl.isWrapping && index === carouselEl.cells.length - 1) {
                            navNextEl.setAttribute(`disabled`, true);
                        }
                    }
                }
    
                if (navPrevEl && navNextEl) {
                    navPrevEl.addEventListener(`click`, e => {
                        console.log(`[LSG] Previous clicked.`);
                        carouselEl.previous();
                    });
    
                    navNextEl.addEventListener(`click`, e => {
                        console.log(`[LSG] Next clicked.`);
                        carouselEl.next();
                    });
                }
    
                navDotEls.forEach((navDotEl) => {
                    navDotEl.addEventListener(`click`, e => {
                        console.log(`[LSG] Nav dot clicked.`);
                        const index     = navDotEl.getAttribute(`lsg-carousel-nav-dot-index`);
                        carouselEl.select(index);
                    });
                });
            }
        }
    
    
        /**
         * Theme Editor Events
         */
        document.addEventListener(`shopify:section:load`, e => {
            const sectionId         = e.detail.sectionId,
                  carouselSectionEl = e.target.querySelector(`[data-section-id="${sectionId}"]`),
                  carouselActualEl  = carouselSectionEl.querySelector(`[lsg-carousel]`),
                  carouselEl        = Flickity.data(carouselActualEl);

            carouselEl?.destroy();
            buildCarousel(carouselSectionEl);
        });

        document.addEventListener(`shopify:block:select`, e => {
            const blockEl       = e.target,
                  sectionEl     = blockEl.closest(`[data-section-id]`),
                  carouselEl    = Flickity.data(sectionEl.querySelector(`[lsg-carousel]`));

            const slideIndex = [].indexOf.call(e.target.parentElement.children, e.target);
            carouselEl.select(slideIndex, true, true);
            carouselEl.resize();
        });


    }
}
export default lsg_carousel_rebuild;